export default __webpack_public_path__ + "static/media/headset.88d6a4fd.png";